'use client';

import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { forwardRef } from 'react';

import { buttonVariants } from './button';
import { cn } from '../lib/utils';

const ToggleGroup = forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root>
>(({ className, children, ...props }, ref) => (
  <ToggleGroupPrimitive.Root ref={ref} className={cn('flex flex-wrap gap-3', className)} {...props}>
    {children}
  </ToggleGroupPrimitive.Root>
));

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => {
  return (
    <ToggleGroupPrimitive.Item
      ref={ref}
      className={cn(
        buttonVariants({ variant: 'primary' }),
        'flex items-center justify-center gap-2 px-3.5 py-2.5',
        'bg-steel-100 text-steel-400 border border-transparent font-semibold',
        'hover:border-steel-75 hover:bg-steel-100',
        'active:bg-brand-300 active:border-transparent active:text-white',
        'data-[state=on]:enabled:bg-brand-300 data-[state=on]:enabled:border-transparent data-[state=on]:enabled:text-white',
        'disabled:bg-steel-100 disabled:border-transparent',
        className,
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Item>
  );
});

ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
